export const locale = {
	lang: 'en',
	data: {
		menu_pwa: 'PWAs',
		my_companies_header_navbar: 'My Companies',
		companies_search: 'Type to search',

		language_header_navbar: 'Languages',
		theme_mode_header_navbar: 'Theme mode',
		account_manage_header_navbar: 'Account manage',
		sign_out_header_navbar: 'Sign out',
		light_mode_header_navbar: 'Light',
		dark_mode_header_navbar: 'Dark',
		system_mode_header_navbar: 'System',
		add_company_header_navbar: 'Company',

		en_EN: 'English',
		fr_FR: 'French',
		es_ES: 'Spanish',
		pt_PT: 'Portuguese',

		drawer_back: 'Back',
		drawer_create: 'Create',
		drawer_update: 'Update',

		paginator_showing: 'Displaying',
		paginator_items: 'items',
		paginator_of: 'out of',

		you_are_about_to_delete: 'You are about to delete {{typeTitle}} {{itemName}}!',
		once_deleted: 'Once deleted, this item cannot be recovered.',
		are_you_sure: 'Are you sure you want to delete?',
		cancel: 'Cancel',
		i_want_to_delete: 'I want to delete',

				the_company_will_no_longer: 'The company will no longer be listed. All company data will be deleted.',
		create_a_company: 'Create your company',
		create_company_information: 'Company Information',
		create_company_information_description: 'Please provide the business information about your company. For billing purposes, pay attention to all fields marked with *.',

		create_company_form_label_name: 'Name',
		create_company_form_label_legal_name: 'Legal name',
		create_company_form_label_vat: 'VAT',
		create_company_form_label_email: 'Email',
		create_company_form_label_city: 'City',
		create_company_form_label_country: 'Country',
		create_company_form_label_address: 'Address',
		create_company_form_label_zipcode: 'Zip code',
		create_company_form_label_phone: 'Phone contact',
		create_company_form_label_website: 'Website',

		create_company_form_label_name_placeholder: 'Ex.: ABC Corporation',
		create_company_form_label_legal_name_placeholder: 'Ex.: ABC Holdings Ltd.',
		create_company_form_label_vat_placeholder: 'Ex.: GB123456789',
		create_company_form_label_email_placeholder: 'Ex.: contact@company.com',
		create_company_form_label_city_placeholder: 'Ex.: London',
		create_company_form_label_country_placeholder: 'Ex.: United Kingdom',
		create_company_form_label_address_placeholder: 'Ex.: 123 Business Park, Main Street',
		create_company_form_label_zipcode_placeholder: 'Ex.: A1 A12',
		create_company_form_label_phone_placeholder: 'Ex.: +00 000 1234 5678',
		create_company_form_label_website_placeholder: 'Ex.: https://www.company.com',
		create_company_form_label_name_error: 'Name is required',
		create_company_form_label_legal_name_error: 'Legal name is required',
		create_company_form_label_vat_error: 'VAT number is required',
		create_company_form_label_email_error: 'Email is required',
		
		create_webhook_address_cancelation: 'Webhook Address Cancelation',
		create_webhook_address_confirmation: 'Webhook Address Confirmation',
		create_webhook_address_sale: 'Webhook Address Sale',
		create_webhook_address_cancelation_placeholder: 'Enter webhook address cancelation',
		create_webhook_address_confirmation_placeholder: 'Enter webhook address confirmation',
		create_webhook_address_sale_placeholder: 'Enter webhook address sale',


		create_company_form_click_here_select_logotype: 'Click here to select the logotype',
		create_company_form_click_here_select_cover_image: 'Click here to select the cover image',

	
		edit_company_page_title: 'Company Information',
		edit_company_page_description: 'Edit your company information',

		
		create_company_save_company: 'Save',

		table_head_label_name: 'Name',
		table_head_label_priority: 'Priority',
		table_head_label_status: 'Status',
		table_head_label_actions: 'Actions',
		table_head_label_start: 'Start date',
		table_head_label_end: 'End date',
		table_head_label_type: 'Type',
		table_head_label_gateways: 'Gateways',
		table_head_label_payment_methods: 'Payment Methods',
		table_head_label_store_name: 'Store',
		table_head_label_amount: 'Amount',
		table_head_label_start_date: 'Start date',
		table_head_label_final_date: 'End Date',
		table_head_label_date: 'Date',
		table_head_label_gateway: 'Gateway',
		table_head_label_payment_method: 'Payment method',
		table_head_label_validity: 'Validity',
		table_head_label_stores: 'Stores',
		table_head_label_company_name: 'Company',
		table_head_label_legal_name: 'Legal name',
		table_head_label_role: 'Role',
		table_head_label_active: 'Active',

		active_company_header_navbar: 'Active Company',
		active_company_informations_header_navbar: 'Company Information',
		active_company_users_header_navbar: 'User management',
		active_company_roles_header_navbar:'User roles',


		company_user_management_page_title: 'User Management',
		company_user_management_page_description: 'Manage users associated with your company',
		company_user_management_send_invite: 'Send Invite',

		

		toast_user_role_updated: 'User role updated successfully',
		toast_error_updating_user_role: 'There was an error updating the role',

		toast_error_no_grant: 'You do not have permission to perform this action',

		company_roles_page_title: 'Roles',
		company_roles_page_description: "Information about the company's linked user roles",
		company_role_create_role: 'Add role',

		invite_user_drawer_title: 'Invite User',
		invite_user_drawer_description: 'Invite a new user to join the company by filling out the form below.',
		invite_user_drawer_email: 'Email',
		invite_user_drawer_email_placeholder: 'User email',
		invite_user_email_error: 'Email is mandatory',
		invite_user_drawer_role: 'User role',
		select_role_placeholder: 'Select a role',
		send_invitation: 'Send invite',

		invitation_sent_successfully: 'Invitation sent successfully',
		error_sending_invitation: 'There was an error sending the invitation',

		the_user: 'the user',
		the_user_will_be_removed: 'The user will be removed from the company and will no longer have access to its resources.',
		toast_user_role_deleted: 'The user has been removed',
		toast_error_deleting_user_role: 'An error occurred while removing the user',
		toast_user_role_not_been_deleted: 'The user has not been removed.',

		create_role_drawer_title: 'Create a role',
		create_role_drawer_description: 'Fill out the form to create the role. All fields must be completed. Fields marked with * are mandatory.',
		create_role_drawer_label_name: 'Name',
		create_role_drawer_label_actions: 'Actions',
		create_role_drawer_label_invites: 'Invitations',
		create_role_drawer_label_resource: 'Resources',
		create_role_drawer_label_active: 'Active',
		create_role_drawer_label_permissions: 'Permissions',
		create_role_drawer_label_company: 'Companies',
		create_role_drawer_label_role: 'Roles',
		create_role_drawer_label_users: 'Users',
		create_role_drawer_label_create: 'Create',
		create_role_drawer_label_read: 'Read',
		create_role_drawer_label_update: 'Update',
		create_role_drawer_label_delete: 'Delete',
		create_role_drawer_label_name_placeholder: 'Role name',
		create_role_drawer_label_api_keys: 'API Access Keys',

		toast_role_created: 'The role has been created.',
		toast_error_creating_role: 'An error occurred while creating the role.',
		toast_role_updated: 'The role has been updated.',
		toast_error_updating_role: 'An error occurred while updating the role.',
		toast_role_status_updated: 'The role status has been updated.',
		toast_error_updating_role_status: 'An error occurred while updating the role status.',
		toast_role_not_updated: 'The role has not been updated.',
		toast_role_not_created: 'The role has not been created.',
		toast_role_deleted: 'The role has been deleted.',
		toast_error_deleting_role: 'An error occurred while deleting the role.',
		toast_role_not_been_deleted: 'The role has not been deleted.',
		the_role: 'the role',
		the_role_will_be_removed: 'The role will be removed from all places where it is being used.',

		pwa_page_title: 'PWA',
		pwa_page_description: 'Edit your PWAs',
		pwa_create_pwa: 'Create PWA',
		toast_status_pwa_changed: 'PWA status changed',
		toast_error_changing_pwa_status: 'Error changing PWA status',

		edit_pwa_drawer_title: 'Edit PWA',
		create_pwa_drawer_title: 'Create PWA',
		create_edit_pwa_drawer_description: 'Create or edit your pwa',
		create_pwa_form_label_name: 'PWA Name',
		create_pwa_form_label_image: 'Image',
		create_pwa_form_label_luope_id: 'Luope ID',
		create_pwa_form_label_shared_key: 'Shared Key',
		create_pwa_form_label_subdomain: 'Subdomain',
		create_pwa_form_label_theme: 'Theme',

		create_pwa_form_placeholder_name: 'Insert name',
		create_pwa_form_placeholder_luope_id: 'Insert Luope ID',
		create_pwa_form_placeholder_shared_key: 'Insert shared Key',
		create_pwa_form_placeholder_subdomain: 'Insert subdomain',
		create_pwa_form_placeholder_theme: 'Insert Theme',
		update_pwa: 'Update PWA',
		create_pwa: 'Create PWA',
		toast_pwa_created: 'PWA created successfully',
		toast_error_creating_pwa: 'There was an error creating PWA',
		toast_pwa_updated: 'PWA updated successfully',
		toast_error_updating_pwa: 'There was an error updating PWA',

		toast_error_loading_pwa:'Error loading PWAs',
		toast_pwa_not_been_deleted: 'PWA has not been deleted',
		toast_error_deleting_pwa: 'There was an error deleting PWA',
		toast_pwa_deleted: 'PWA deleted successfully',
		invalid_json_format: 'Invalid format for this field',

		error_required_field: 'This field is required',

		menu_files: 'Files',
		sidebar_more: 'More',
		company_files_page_title: 'Files',
		company_files_page_description: 'Upload and manage your files',
		company_files_create_file: 'File',

		create_loading_file_drawer_title: 'File upload',
		create_loading_file_drawer_description: 'Track the progress of your files',
		create_loading_file_drawer_upload: 'Choose files',

		select_files_drawer_title: 'File selection',
		select_files_drawer_description: 'Select the files to integrate into the company, store, and/or store products',

		toast_files_created: 'The files have been uploaded.',
		toast_files_created_error: 'An error occurred when uploading the files',
		toast_files_tried_upload_not_accepted: 'The files you tried to upload are not accepted. Only jpeg, jpg, svg or png files will be accepted.',
		toast_file_deleted: 'The file has been deleted.',
		toast_error_deleting_file: 'An error occurred when deleting a file.',
		toast_file_not_been_eliminated: 'The file has not been deleted.',


		the_file: 'the file',
		the_file_will_be_removed: 'The file will be removed from all places where it is being used.',

		toast_error_company_files: 'An error occurred when loading the files',
		toast_error_server: 'There was an error while reaching the server. Please try again.',

		toast_company_created: 'The company was created successfully.',
		toast_error_creating_company: 'There was an error creating the company.',
		toast_info_file_selected: 'File selected.',
		toast_company_eliminated: 'The company was removed successfully.',
		toast_error_deleting_company: 'There was an error deleting the company.',
		toast_company_not_been_eliminated: 'The company was not removed successfully.',
		toast_company_updated: 'The company was updated successfully.',
		toast_error_updating_company: 'There was an error updating the company.',
		the_pwa_will_be_removed: 'The PWA will be removed.',
		the_pwa: 'The PWA',
		location_not_authrozied_warning: 'Location permissions have not been granted.',

		create_pwa_form_label_final_message: 'Machine usage message',
		create_pwa_form_placeholder_final_message: 'Insert the machine usage message',

		create_pwa_form_label_final_message_switch: 'Show machine usage message',
		create_pwa_form_label_logo: 'PWA logo',
		create_pwa_form_label_cover: 'PWA Cover',

		create_pwa_form_label_customization: 'Customization',
		create_pwa_form_label_color: 'Color',

        theme_primary_color: 'Primary Color',
        theme_secondary_color: 'Secondary Color',
        theme_background_color: 'Background Color',
        theme_accent_color: 'Accent Color',
        theme_action_color: 'Action Color',
        theme_success_color: 'Success Color',
        theme_warning_color: 'Warning Color',
        theme_danger_color: 'Danger Color',
        theme_logo_cover_color: 'Logo Cover Color',
        theme_primary_font_color: 'Primary Font Color',
        theme_secondary_font_color: 'Secondary Font Color',
        theme_btn_action_color: 'Button Action Color',
        theme_btn_font_action_color: 'Button Font Action Color',
        theme_highlight_font_color: 'Highlight Font Color',
        
        theme_description_primary_color: 'The primary color used throughout the application',
        theme_description_secondary_color: 'The secondary color used throughout the application',
        theme_description_background_color: 'The background color of the application',
        theme_description_accent_color: 'The accent color for highlights',
        theme_description_action_color: 'The color for user action elements',
        theme_description_success_color: 'The color for success states',
        theme_description_warning_color: 'The color for warning states',
        theme_description_danger_color: 'The color for error states',
        theme_description_logo_cover_color: 'The color for the logo cover',
        theme_description_primary_font_color: 'The primary text color',
        theme_description_secondary_font_color: 'The secondary text color',
        theme_description_btn_action_color: 'The color for user action buttons',
        theme_description_btn_font_action_color: 'The text color for user action buttons',
        theme_description_highlight_font_color: 'The highlight text color',

		reset_theme: 'Reset theme',

	}
};
